<div class="table-filter pb-2 border-bottom">
    <form class="d-flex flex-row align-items-center flex-wrap justify-content-start" [formGroup]="form">
    <fieldset class="d-contents">
        <legend class="visually-hidden">Filter compliance items</legend>
        <edl-floating-label-container label="Status" for="user-summary-change-status"   class="w-auto mt-2 me-2">
            <select id="user-summary-change-status" class="form-select" name="cbStatusFilter" formControlName="archived">
                <option value="">Active</option>
                <option value="Archived">Archived</option>
            </select>
        </edl-floating-label-container>
        <edl-floating-label-container *ngIf="canViewItemPackets" label="Item Packets" for="itemPacketFilterUserSummary" class="w-auto mt-2 me-2">
            <item-packet-filter id="itemPacketFilterUserSummary" [formGroup]="form.get('filterByItemPacket')" [itemPackets]="itemPacketEntries"></item-packet-filter>
        </edl-floating-label-container>
    </fieldset>
        <div class="align-items-left mt-2">
            <a *ngIf="canAssignItems && !isMyItems" class="btn btn-secondary ms-2 d-flex align-items-center" style="height: calc(3rem + 2px);" uiSref="authenticated.all-users-progress.bulk-add" [uiParams]="{ userId: user.UserID }">
                <i class="fas fa-plus" aria-hidden="true"></i> Assign Item(s)
            </a>
        </div>
        <div class="requests-btn-container align-items-right mt-2">
            <a *ngIf="showReturnToAllUsersProgress" class="btn btn-cancel ms-2 d-flex align-items-center" style="height: calc(3rem + 2px);"
                    (click)="clickReturnToAllUsersProgress()">
                    <i class="fas fa-arrow-left me-1" aria-hidden="true"></i>Return to All Users' Progress
            </a>
        </div>
    </form>    
</div>
<ul class="mobile-grid d-lg-none overflow-box">
    <li class="item" *ngFor="let summaryItem of summaryItems">
        <div class="status-indicator"><status-indicator [statusLabel]="summaryItem?.UserCycle?.PendingStatus"  [statusId]="summaryItem?.UserCycle?.UserStatus"></status-indicator></div>
        <div class="row">
            <div class="offset-1 col-11 ">
                <strong>
                    <a *ngIf="summaryItem?.CplItem?.CanView && !isUser" class="roster-link" uiSref="authenticated.compliance-items.compliance-item.roster" [uiOptions]="{reload: true}" [uiParams]="{ complianceItemId: summaryItem?.CplItem?.ItemID, page: 1 }">
                        {{ summaryItem?.CplItem?.Title }}
                    </a>
                    <span *ngIf="!summaryItem?.CplItem?.CanView || isUser">{{ summaryItem?.CplItem?.Title }}</span>
                </strong>

            </div>
        </div>
        <div class="row" *ngIf="canViewItemPackets && summaryItem.CplItem.ItemPackets.length > 0">
            <div class="offset-1 col-11">
                <span *ngFor="let packet of summaryItem.CplItem.ItemPackets; let isLast=last">
                    <item-packet-pill [pill]="packet.Pill" [showStatusStamp]="true"
                        [status]="getInComplianceStatus(packet.Id)"></item-packet-pill>
                    <span class="pill-spacer" *ngIf="!isLast"></span>
                </span>
            </div>
        </div>
        <div class="row">
            <div class="offset-1 col-11">
                <strong>Due Date:</strong>
                {{ summaryItem.UserCycle.EndDate | dateExtended: 'MM/dd/yyyy' }}
            </div>
        </div>
        <div class="row">
            <div class="offset-1 col-11">
                <strong>Days Remaining:</strong>
                <span [ngClass]="{ 'expired' : Negative(summaryItem) }">{{ GetDaysRemaining(summaryItem, (summaryItem.UserCycle.EndDate | amDifference: today : 'days' : false))  }}</span>
            </div>
        </div>
        <div class="row" *ngIf="!!summaryItem?.CplItem?.FlexDetails?.Applicable">
            <div class="flex-indicator-container offset-1 col-11" >
                <strong>Flex:</strong>
                <small class="flex-hours-text">{{getFlexHours(summaryItem)}}</small>
            </div>
        </div>
        <div class="row" *ngIf="!!summaryItem?.CplItem?.Act48Detail?.Applicable">
            <div class="act48-indicator-container offset-1 col-11">
                <strong>Act 48:</strong>
                <timetracking-status-indicator
                    *ngIf="summaryItem.CplItem?.Act48Detail?.Applicable"
                    [statusId]="summaryItem.UserCycle.A48SubmissionStatus"
                    [paraStatusId]="summaryItem.UserCycle.ParaStatus"
                    [isPara]="summaryItem.UserCycle.IsPara"
                    [paraApplicable]="summaryItem.ParaApplicable"
                    [a48ContextCode]="summaryItem.UserCycle.A48ContextCode"
                    statusLabel="Act 48 Submission"
                    [timeTrackingType]="TimeTrackingType.ACT48"
                    [hours]="getHours(summaryItem)"
                    [activityType]="getActivityType(summaryItem)"
                    [showHours]="true"
                    [isUser]="isUser"
                    (onIconClick)="viewDetails(summaryItem, NavigationItemId.ACT48)"
                ></timetracking-status-indicator>
            </div>
        </div>
        <div class="row">
            <div class="offset-1 col-11">
                <strong>Evidence:</strong>
                <compliance-item-evidence
                    [complianceItem]="summaryItem.CplItem"
                    [cplCycle]="summaryItem.UserCycle"
                    [isUser]="isUser"
                    (onRefreshList)="refreshList()">
                </compliance-item-evidence>
            </div>
        </div>
        <div class="row" style="margin-top: 5px;" *ngIf="!isUser">
            <div class="col-12">
                <cpl-roster-actions *ngIf="!summaryItem.UserCycle.IsArchived"
                    [ngStyle]="{ '--cpl-roster-actions-button-width': '100%' }"
                    [complianceItem]="summaryItem.CplItem"
                    [cplCycle]="summaryItem.UserCycle"
                    [isHistory]="false" 
                    (onRefreshList)="refreshList()">
                </cpl-roster-actions>
            </div>
        </div>
        <div class="row" style="margin-top: 5px;" *ngIf="!isUser">
            <div class="col-12">
                <cpl-roster-actions class="input-group mobile-group w-100"
                    [ngStyle]="{ '--cpl-roster-actions-button-width': '100%' }"
                    [complianceItem]="summaryItem.CplItem"
                    [cplCycle]="summaryItem.UserCycle"
                    [isHistory]="false" 
                    [type]="CplRosterActionsTypes.APPROVE"
                    (onRefreshList)="refreshList()">
                </cpl-roster-actions>
            </div>
        </div>
        <div *ngIf="!summaryItem.CanView && !isUser" class="row" style="margin-top: 5px;">
            <compliance-item-action-button [customClasses]="{ 'w-100': true }"  [actionName]="ActionName.REQUEST_ACCESS" [complianceItem]="summaryItem.CplItem" [isDropdownItem]="false"></compliance-item-action-button>
        </div>
        <div class="row" style="margin-top: 5px; align-content: center;">
            <div *ngIf="summaryItem.CanView" class="col-12">
                <button class="btn btn-info form-control"
                        (click)="onViewItem(summaryItem)">View</button>
            </div>
        </div>
    </li>
</ul>

<table class="table table-striped d-none d-lg-block">
    <caption class="visually-hidden">User compliance items</caption>
    <thead>
        <tr>
            <th scope="col" class="text-center fit"><sort-by label="Status" field="Status"></sort-by></th>
            <th scope="col"><sort-by label="Item Name" field="Title"></sort-by></th>
            <th scope="col" *ngIf="canViewItemPackets"><span class="visually-hidden">Item packets</span></th>
            <th scope="col"><sort-by label="Due Date" field="DueDate"></sort-by></th>
            <th scope="col" class="text-center">Days Remaining</th>
            <th scope="col" class="fit user-summary-flex-column">Flex</th>
            <th scope="col" class="fit user-summary-act48-column" *ngIf="portalSettings.Act48Enabled">Act 48</th>
            <th scope="col" class="text-center"><span class="visually-hidden">Evidence</span></th>
            <th scope="col" class="text-center fit">Actions</th>
            <th scope="col" class="fit" *ngIf="!isUser"><span class="visually-hidden">Approve</span></th>
            <th scope="col" class="fit" *ngIf="!isUser"><span class="visually-hidden">View details</span></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let summaryItem of summaryItems">
            <td class="text-center fit user-summary-status-column">
                <status-indicator [statusLabel]="summaryItem.UserCycle.PendingStatus"  [statusId]="summaryItem.UserCycle.ActionRequired ? 4 : summaryItem?.UserCycle?.UserStatus"></status-indicator>
            </td>
            <td class="word-wrap user-summary-title-column">
                <a *ngIf="summaryItem?.CplItem?.CanView && !isUser" class="roster-link" uiSref="authenticated.compliance-items.compliance-item.roster" [uiOptions]="{reload: true}" [uiParams]="{ complianceItemId: summaryItem.CplItem.ItemID, page: 1 }">
                    {{summaryItem.CplItem.Title}}
                </a>
                <span *ngIf="!summaryItem?.CplItem?.CanView || isUser">{{summaryItem.CplItem.Title}}</span>
            </td>
            <td *ngIf="canViewItemPackets">
                <span *ngFor="let packet of summaryItem.CplItem.ItemPackets; let isLast=last">
                    <item-packet-pill [pill]="packet.Pill" [showStatusStamp]="true"
                        [status]="getInComplianceStatus(packet.Id)"></item-packet-pill>
                    <span class="pill-spacer" *ngIf="!isLast"></span>
                </span>
            </td>
            <td class="user-summary-date-column">{{ summaryItem?.UserCycle?.EndDate | dateExtended: 'MM/dd/yyyy' }}</td>
            <td class="text-center user-summary-remaining-days" [ngClass]="{ 'expired' : Negative(summaryItem) }">{{ GetDaysRemaining(summaryItem, (summaryItem?.UserCycle?.EndDate | amDifference: today : 'days' : false))  }}</td>
            <td class="fit user-summary-flex-column">
                <div *ngIf="summaryItem.CplItem?.FlexDetails?.Applicable">
                    <span>{{getFlexHours(summaryItem)}}</span>
                </div>
            </td>
            <td class="fit user-summary-act48-column" *ngIf="portalSettings.Act48Enabled">
                <timetracking-status-indicator
                    *ngIf="summaryItem.CplItem?.Act48Detail?.Applicable"
                    [statusId]="summaryItem.UserCycle.A48SubmissionStatus"
                    [paraStatusId]="summaryItem.UserCycle.ParaStatus"
                    [isPara]="summaryItem.UserCycle.IsPara"
                    [paraApplicable]="summaryItem.ParaApplicable"
                    [a48ContextCode]="summaryItem.UserCycle.A48ContextCode"
                    statusLabel="Act 48 Submission"
                    [timeTrackingType]="TimeTrackingType.ACT48"
                    [hours]="getHours(summaryItem)"
                    [activityType]="getActivityType(summaryItem)"
                    [showHours]="true"
                    [isUser]="isUser"
                    (onIconClick)="viewDetails(summaryItem, NavigationItemId.ACT48)"
                ></timetracking-status-indicator>
            </td>
            <td class="text-center user-summary-evidence-column">
                <compliance-item-evidence
                    [complianceItem]="summaryItem.CplItem"
                    [cplCycle]="summaryItem.UserCycle"
                    [isUser]="isUser"
                    (onRefreshList)="refreshList()">
                </compliance-item-evidence>
            </td>
            <td class="text-center fit user-summary-actions-column" *ngIf="!isUser">
                <cpl-roster-actions *ngIf="!summaryItem.UserCycle.IsArchived"
                    [complianceItem]="summaryItem.CplItem"
                    [cplCycle]="summaryItem.UserCycle"
                    [isHistory]="false" 
                    (onRefreshList)="refreshList()">
                </cpl-roster-actions>
            </td>
            <td class="text-center fit" *ngIf="!isUser">
                <cpl-roster-actions
                    [complianceItem]="summaryItem.CplItem"
                    [cplCycle]="summaryItem.UserCycle"
                    [isHistory]="false" 
                    [type]="CplRosterActionsTypes.APPROVE"
                    (onRefreshList)="refreshList()">
                </cpl-roster-actions>
            </td>
            <td class="fit">
                <compliance-item-action-button *ngIf="!summaryItem.CanView && !isUser" [actionName]="ActionName.REQUEST_ACCESS" [complianceItem]="summaryItem.CplItem" [isDropdownItem]="false"></compliance-item-action-button>
                <button class="btn btn-info user-summary-details-button"
                    *ngIf="summaryItem.CanView"
                    (click)="onViewItem(summaryItem)">View</button>
            </td>
        </tr>
    </tbody>
</table>

<div id="user-summary-no-items-found" class="content" *ngIf="summaryItems.length === 0">
    No items found.
</div>